export const getCaseDefaultAccountIds = (caseDetails, caseAndLeadsList) => {
  const caseData = caseAndLeadsList?.case_list?.[0] ?? caseAndLeadsList?.lead_list?.[0] ?? caseDetails;

  return {
    defaultTrustId: caseData?.default_trust_account?.[0]?.account_id ?? null,
    defaultOperatingId: caseData?.default_operating_account?.[0]?.account_id ?? null,
  };
};

export const isMappedViaCaseDefault = (depositAccountId, caseDetails, caseAndLeadsList) => {
  if (!depositAccountId) {
    return false;
  }

  const { defaultTrustId, defaultOperatingId } = getCaseDefaultAccountIds(caseDetails, caseAndLeadsList);

  return depositAccountId === defaultTrustId || depositAccountId === defaultOperatingId;
};
